import type { HoldBackProductionType } from '@threadheads/shared';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

/**
 * POD / PAP marker, in the outline-badge treatment the Inventory list already
 * uses for its production-type column (`InventoryTableList`).
 *
 * It carries INFORMATION, not decoration: since BLU-1856 gave Stock Hold-Back a
 * production-type axis, the same product type string ("T-Shirt") legitimately
 * appears twice on one surface meaning two different physical things, so the
 * label alone no longer identifies a row.
 *
 * No fill colour, and never colour alone (DESIGN §16) — the acronym IS the
 * signal, and POD/PAP are the operators' own vocabulary in both locales. The
 * spelled-out meaning lives on the surrounding control's `aria-label` and on
 * the section explainer, so the badge itself adds no screen-reader noise.
 */
export function ProductionTypeBadge({
  productionType,
  className,
}: {
  productionType: HoldBackProductionType;
  className?: string;
}) {
  return (
    <Badge
      variant="outline"
      className={cn('shrink-0 px-1.5 py-0 text-[10px] font-semibold tracking-wide', className)}
    >
      {productionType}
    </Badge>
  );
}
